export enum FileTypeEnum {
    SchoolFile = 1,
    SpecialistChildrenFirstCertificate = 2,
    SpecialistInsuranceCertificate = 3,
    SpecialistTrainingCertificate = 4,
    VCFForm = 5
}
